import React from "react";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import ProductGrid from "./components/ProductGrid";

function App() {
  return (
    <div className="App">
      <Navbar />
      <ProductGrid />
      <Footer />
    </div>
  );
}

export default App;
